import { httpClient } from "../../httpClient";
import { Feedback } from "../../../store";

type Payload = {
  feedbackId: string;
  feedbackType: string;
  details: string;
  status: string;
  dateTimeAdded: string;
  sentBy: string;
  feedbackSubject: string;
  businessUnit: string;
};

type Data = any;

export async function editFeedback(id: Feedback["id"], payload: Payload): Promise<boolean> {
    try {
        const response = await httpClient.put(`/api/v1/feedback/${id}`, payload);

        return response.status === 200;
    } catch (error) {
        throw error;
    }
}

export const feedback = {
  editFeedback
};